module.exports = __webpack_public_path__ + "static/rotimi-c045eb2156b68a10189418c4794962d7.jpg";